import { FormattedMessage } from "react-intl";
import { getExploreDuration } from "./exploreDuration.ts";

export default function ExploreDurationMessage({
  asset,
  daysOnly,
}: {
  asset: VST.Bridge.Asset;
  daysOnly?: boolean;
}) {
  const { hasDuration, days, hours } = getExploreDuration(asset);

  if (!hasDuration) {
    return null;
  }

  if (days === 0) {
    if (daysOnly) {
      return <FormattedMessage defaultMessage="Expires in less than 1 day" />;
    }

    if (hours === 0) {
      return <FormattedMessage defaultMessage="Expires in less than 1 hour" />;
    }

    return (
      <FormattedMessage
        defaultMessage="Expires in {time, plural, =1 {1 day} other {# hours}}"
        values={{
          time: hours,
        }}
      />
    );
  }

  return (
    <FormattedMessage
      defaultMessage="Expires in {time, plural, =1 {1 day} other {# days}}"
      values={{
        time: days,
      }}
    />
  );
}
